export const accessTokenKey = 'accessToken';
export const fakeUserNameKey = 'fakeUserName';
export const dbSchemaHashKey = 'orderConfigHashV2'; //todo: actualise
export const dbTenantKey = 'dbTenant';
export const clientInstanceIdKey = 'clientInstanceId';
